<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ep">
<div class="epigraph">
<p class="ep"><a class="page"></a></p>
<p class="ep" style="text-align: center;">I think it’s a metaphysical concept</p>
<p class="ep" style="text-align: center;">starting with Aristotle and flowering in St. Thomas</p>
<p class="ep" style="text-align: center;">that God is pure act and that there is no potentia in Him.</p>
<p class="ep" style="text-align: center;">. . . Almost everything else in the universe is in potentia,</p>
<p class="ep" style="text-align: center;">it’s on its way to being pure act,</p>
<p class="ep" style="text-align: center;">on its way to unity with God.</p>
<p class="ept">Robert Lax</p>
<p class="ep">Depending upon the reader, it is all either baffling or beatific.</p>
<p class="ept">American Library Association Booklist review of <i>33 Poems</i>, the first Lax book issued by a major American publisher</p>
</div><a class="page" id="px"></a><a class="page" id="p1"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// McGregor0006.vue?1e12fe74